import React from "react";
import { GameSpotlight } from "../../contenful/types";
import "./styles/GameSpotlightComponent.scss";
import Markdown from "react-markdown";
import { prettyUrl } from "../../utils/UrlUtils";
import { Link } from "react-router-dom";
import { t } from "../../i18n";

interface Props {
  section: GameSpotlight;
  mobile: boolean;
}

const GameSpotlightComponent: React.FC<Props> = ({ section }) => {
  const backgroundColor = section && section.backgroundColor ? section.backgroundColor : "";
  const bgAnimateLeft = section.backgroundAnimationType && section.backgroundAnimationType[0] === "Move Left" ? "scroll-left" : "";
  const bgAnimateRight = section.backgroundAnimationType && section.backgroundAnimationType[0] === "Move Right" ? "scroll-right" : "";
  const bgAnimateBackAndForth = section.backgroundAnimationType && section.backgroundAnimationType[0] === "Move Back and Forth" ? "scroll-back-forth" : "";
  const logoAnimateUpAndDown = section.logoAnimationType && section.logoAnimationType[0] === "Up and Down" ? "move-up-down" : "";
  const logoAnimateZoomInOut = section.logoAnimationType && section.logoAnimationType[0] === "Zoom in and Zoom out" ? "zoom-in-out" : "";

  return (
    <div className={`gameSpotlight`} style={{ backgroundColor: backgroundColor }}>
      <div className={`container`}>
        <div className={`inner-section`}>
          {section.title && <h4 className="title">{section.title}</h4>}
          <div className="container-inner">
            <div className="text-content">
              {section.description && (
                <div className="description">
                  <Markdown children={section.description} />
                </div>
              )}
              {section.gameType && <p className="game-type">{section.gameType}</p>}
              {section.provider && <p className="provider">{section.provider}</p>}
              {section.gameId && section.gameName && (
                <div className={"gameSpotLight-playButtonContainer"}>
                  <Link to={`/casino/play/${section.gameId}/${prettyUrl(`${section.gameName}`)}/auto`} className="btn height">
                    {t("casino.playGame")}
                  </Link>
                </div>
              )}
            </div>
            <div className="image-content">
              {section.backgroundImage && section.backgroundImage.fields && <img src={section.backgroundImage.fields.file.url} className={`bg ${bgAnimateLeft}${bgAnimateRight}${bgAnimateBackAndForth}`} alt={section.backgroundImage.fields.title ? section.backgroundImage.fields.title : ""} />}
              {section.logoImage && section.logoImage.fields && <img src={section.logoImage.fields.file.url} className={`logo ${logoAnimateUpAndDown}${logoAnimateZoomInOut}`} alt={section.logoImage.fields.title ? section.logoImage.fields.title : ""} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameSpotlightComponent;
